import { Modal } from '~/components/modal';
import { ProgressiveConfiguration } from '~/gql/__generated__/types';
import Image from 'next/image';
import Button from '~/components/button';
import styles from './progressive-learn-modal.module.scss';

interface IProgressiveLearnModalProps {
  isModalOpen: boolean;
  toggleModal: () => void;
  progressiveConfigs: ProgressiveConfiguration;
}

const ProgressiveLearnModal: React.FC<IProgressiveLearnModalProps> = ({
  isModalOpen,
  toggleModal,
  progressiveConfigs,
}) => {
  const leasingModal = progressiveConfigs?.progressiveLeasingModal;

  const handleApplyNowClick = () => {
    if (leasingModal?.modalCTA?.linkUrl) {
      window.open(
        leasingModal.modalCTA.linkUrl,
        leasingModal.modalCTA.openInNewTab ? '_blank' : '_self',
      );
    }
  };

  const ctaLink = leasingModal?.modalCTA && (
    <Button onClick={handleApplyNowClick}>
      {leasingModal.modalCTA.linkText}
    </Button>
  );

  const modalBody = (
    <div className={styles.body}>
      {leasingModal?.leasingModalHeader && (
        <h2 className={styles.heading} tabIndex={0}>
          {leasingModal.leasingModalHeader}
        </h2>
      )}

      {leasingModal?.description && (
        <p className={styles.offerDescription} tabIndex={0}>
          {leasingModal.description}
        </p>
      )}

      {leasingModal?.highlights && leasingModal.highlights.length > 0 && (
        <div className={styles.highlightSection}>
          <Image
            src="/makeapayment/icons/payment-connector/progressive-logo.svg"
            alt="progressive-logo"
            className={styles.progressiveLogo}
            width={250}
            height={100}
            tabIndex={0}
          />
          <div tabIndex={0} className={styles.benefitsLabel}>
            <p>
              Get It Today, <span>Own It In 12 Months or Less!</span>
            </p>
          </div>
          <ul className={styles.benefitsList}>
            {leasingModal.highlights.map((highlight, index) => (
              <li key={index} tabIndex={0}>
                <span tabIndex={-1}>{highlight}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {leasingModal?.offerDetails && (
        <p className={styles.offerAgreement} tabIndex={0}>
          {leasingModal.offerDetails}
        </p>
      )}

      {ctaLink && <section className={styles.buttonSection}>{ctaLink}</section>}
    </div>
  );

  return (
    <Modal
      headerTitle="Progressive Leasing"
      modalBody={modalBody}
      isOpen={isModalOpen}
      toggleModal={toggleModal}
      className={styles.progressiveModal}
    />
  );
};

export default ProgressiveLearnModal;
